export interface CreateDraftClaimModel {
  insuredContactInfo?: {
    contactId: number;
  };
  claimNumber?: string;
  sourceSystem: string;
  lobCode: string;
  lossDate: string;
  openDate: string;
  policyNumber: string;
  vehicleNotOnPolicy?: boolean;
  claimContacts?: ClaimContact[];
  reportedBy?: {
    contactId: number;
  };
  reportedByType?: string;
  reportedOn: string;
  reportedTime: string;
  lossLocationAddress: LossLocationAddress[];
  vehicleDetails?: VehicleDetails[];
  policySource?: string;
}

export interface LossLocationAddress {
  addressLine1?: string;
  addressLine2?: string;
  city: string;
  state: string;
  zip?: string;
}

export interface VehicleDetails {
  vehLossDriverContact?: {
    contactId: number;
  };
  vehLossPassenger?: [
    {
      contactId: number;
    },
  ];
  vehLossIsThirdParty?: string;
  vehDamageDamageDescription?: string;
  vehTypeVin?: string;
  vehTypeYear: string;
  vehTypeMake: string;
  vehTypeModel: string;
  vehicleDamages?: VehicleDamage[];
}

export interface VehicleDamage {
  vehicleDamage: string;
}

export interface ClaimContact {
  contact: {
    contactId?: string | number;
    firstName: string;
    middleName?: string;
    lastName: string;
    newAddress?: [
      {
        addressLine1: string;
        addressLine2: string;
        city: string;
        county?: string;
        state: string;
        zip: string;
        country?: string;
      },
    ];
    newPrimaryPhoneEmail?: InsuredContactPayloadModel;
    sourceSystemIdentifier?: string;
    contactType: string;
    isThirdParty: string;
  };
}

export interface InsuredContactPayloadModel {
  country?: string;
  number: string;
  area?: string;
  type?: string;
  emailAddress?: string;
  emailType?: string;
}

export interface SubmitQuestionStoreModel {
  questionId: string;
  questionType: string;
  draftClaimNumber: string;
  emailAddress?: string;
  phoneNumber?: string;
  preferredContactType?: string;
  vehicleDamagePicker?: SubmitVehicleDamageMap;
  claimantContactForm?: ClaimantContactPayloadModel;
  thirdPartyContactForm?: ThirdPartyContactPayloadModel[];
  numberOfContacts?: number;
  draftClaimInfo?: any;
}

export interface ThirdPartyContactPayloadModel {
  claimContact: ClaimContact;
  vehicleDetail: VehicleDetails | undefined;
  questionId?: string;
  isThirdPartyInjured?: string;
  vehicleInvolved?: boolean;
}

export interface ClaimantContactPayloadModel {
  claimContact: ClaimContact;
  insuranceContact?: ClaimContact;
  vehicleDetail: VehicleDetails | null;
  policyNumber?: string;
  claimNumber?: string;
  insuranceCompanyName?: string;
  insuranceCompanyPhoneExtension?: string;
  questionId?: string;
  isDriver?: string;
}

export interface SubmitVehicleDamageMap {
  damageType: string;
  vehDamageDamageDescription: string;
  vehicleDamages: VehicleDamges[];
}

export interface VehicleDamges {
  vehicleDamage: string;
}

export interface SubmitQuestionApiModel {
  answer: {
    questionId: string;
    singleSelect?: string;
    multipleSelect?: string;
    freeForm?: string;
    claimantContactForm?: ClaimantContactPayloadModel;
    insuredContactType?: {
      email: string;
      areaCode: string;
      phoneNumber: string;
      preferredContactType: string;
    };
    vehicleDamagePicker?: SubmitVehicleDamageMap;
    thirdPartyContactForm?: ThirdPartyContactPayloadModel[];
  } | null;
  draftClaimInfo: CreateDraftClaimModel | null;
}

export enum FnolQuestionTypes {
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  FREE_FORM = 'FREE_FORM',
  VEHICLE_DAMAGE_PICKER = 'VEHICLE_DAMAGE_PICKER',
  INSURED_CONTACT_TYPE = 'INSURED_CONTACT_TYPE',
  THIRD_PARTY_CONTACT_FORM = 'THIRD_PARTY_CONTACT_FORM',
  CLAIMANT_CONTACT_TYPE = 'CLAIMANT_CONTACT_TYPE',
  SUMMARY = 'summary',
  GLASS_END = 'redirect_to_glass_view',
  ERS_END = 'redirect_to_roadside_view',
  END = 'end',
}

export interface ClaimGlassOnly {
  policyNumber: string;
  lossDate: string;
  returnURL?: string;
  returnURL2?: string;
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  email?: string;
  phoneNumber?: string;
  htmlBody?: any;
  loading?: boolean;
  loaded?: boolean;
  status?: any;
}
